export default "__VITE_ASSET__68a6f17c__"